import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { ChevronLeft, ChevronRight } from "lucide-react";
import * as VisuallyHidden from "@radix-ui/react-visually-hidden";

export default function PhotoLightbox({ photos = [], index, onIndexChange, onClose }) {
  const open = index != null;
  const total = photos.length;

  const goPrev = (e) => {
    e?.stopPropagation();
    if (index > 0) onIndexChange(index - 1);
  };
  const goNext = (e) => {
    e?.stopPropagation();
    if (index < total - 1) onIndexChange(index + 1);
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent
        className="max-w-4xl bg-black text-white border-black rounded-none p-2 md:p-4"
        data-testid="photo-lightbox"
      >
        <VisuallyHidden.Root>
          <DialogTitle>Foto Kunjungan</DialogTitle>
          <DialogDescription>Preview foto kunjungan {index + 1} dari {total}</DialogDescription>
        </VisuallyHidden.Root>
        <div className="relative flex items-center justify-center">
          {open && (
            <img
              src={photos[index]}
              alt={`Foto ${index + 1} dari ${total}`}
              className="max-w-full max-h-[80vh] object-contain"
              data-testid="lightbox-image"
            />
          )}
          {total > 1 && (
            <>
              <button
                type="button"
                onClick={goPrev}
                disabled={index === 0}
                data-testid="lightbox-prev"
                className="absolute left-2 top-1/2 -translate-y-1/2 bg-black/70 text-white p-2 border border-white disabled:opacity-30"
                aria-label="Foto sebelumnya"
              >
                <ChevronLeft size={20} />
              </button>
              <button
                type="button"
                onClick={goNext}
                disabled={index === total - 1}
                data-testid="lightbox-next"
                className="absolute right-2 top-1/2 -translate-y-1/2 bg-black/70 text-white p-2 border border-white disabled:opacity-30"
                aria-label="Foto berikutnya"
              >
                <ChevronRight size={20} />
              </button>
            </>
          )}
          <div className="absolute bottom-2 left-1/2 -translate-x-1/2 label-overline bg-black/70 border border-white px-2 py-1">
            {index + 1} / {total}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
